<template>
  <div class="economize-wrap">
    <div class="btn-content" id="editor">
      <el-button @click="savePdf2">打印pdf</el-button>
    </div>
    <div class="economize-content" id="render_me">
      <!-- <div class="report-title">节能空间分析报告</div> -->
      <div class="pdf-con" id="imageDom" ref="imageDom">
        <div
          class="contentOne"
          style="height:1060px;display: flex;flex-flow: column;align-items: center;justify-content: center;"
        >
          <p style="font-size: 30px;text-align: center;font-weight: bold;">{{dataAll.cover.title}}</p>
          <p
            style="font-size: 30px;text-align: center;padding: 10px 0px;"
          >{{dataAll.cover.subtitle}}</p>
          <p style="font-size: 18px;text-align: center;">{{dataAll.cover.time}}</p>
        </div>
        <div class="content">
          <p class="report-title">1.项目概览</p>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr v-if="show">
              <td>项目名称</td>
              <td colspan="8">{{dataAll.descriptionOfProject.projectName}}</td>
              <!-- <td>报告日期</td>
              <td colspan="5">{{dataAll.descriptionOfProject.reportDate}}</td>-->
            </tr>
            <tr v-if="!show">
              <td>项目名称</td>
              <td>{{dataAll.descriptionOfProject.projectName}}</td>
              <td>报告日期</td>
              <td colspan="5">{{dataAll.descriptionOfProject.reportDate}}</td>
            </tr>
            <tr>
              <td>总容量</td>
              <td>{{dataAll.descriptionOfProject.totalCapacity}}</td>
              <td>电压等级</td>
              <td>{{dataAll.descriptionOfProject.voltageGrade}}</td>
              <td>进线路数</td>
              <td colspan="3">{{dataAll.descriptionOfProject.intoTheLineNumber}}</td>
            </tr>
            <tr>
              <td>变压器数量</td>
              <td>{{dataAll.descriptionOfProject.numberOfTransformers}}</td>
              <td>用电类型</td>
              <td>{{dataAll.descriptionOfProject.electricityType}}</td>
              <td>基本电费类型</td>
              <td colspan="3">{{dataAll.descriptionOfProject.basicElectricityType}}</td>
            </tr>
            <tr>
              <td>计价方式</td>
              <td>{{dataAll.descriptionOfProject.priceType}}</td>
              <td>峰期单价</td>
              <td>{{dataAll.descriptionOfProject.peakUnitPrice}}</td>
              <td>谷期单价</td>
              <td>{{dataAll.descriptionOfProject.flatUnitPrice}}</td>
              <td>平期单价</td>
              <td>{{dataAll.descriptionOfProject.valleyUnitPrice}}</td>
            </tr>
            <tr>
              <td>自来水单价</td>
              <td colspan="7">{{dataAll.descriptionOfProject.waterUnitPrice}}</td>
            </tr>
          </table>
          <p class="report-title">2.能源费用类型</p>
          <div class="item-content" v-html="dataAll.overviewOfEnergyCosts"></div>
          <p class="report-title">3.用能成本结构</p>
          <div>
            <pieEchart :chartData="this.dataAll.energyCostStructure" :unit="unit"></pieEchart>
          </div>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>能源分类</td>
              <td colspan="3">能源消耗量</td>
              <td colspan="2">能源消耗比例(%)</td>
            </tr>
            <tr v-for="(item,index) in dataAll.energyCostStructure" :key="index">
              <td>{{item.name}}</td>
              <td colspan="3">{{item.value}}</td>
              <td colspan="2">{{item.ratio}}</td>
            </tr>
          </table>
        </div>
        <div class="content" style="height:1080px">
          <p class="report-title">4.企业用电成本结构分析</p>
          <p class="report-title report-title-2">4.1 企业用电量统计分析</p>
          <div class="echart-content">
            <echartsItem
              :chartData="this.dataAll.analysisOfElectricityCostStructure.statisticalAnalysisOfElectricity.echarts"
            ></echartsItem>
          </div>
          <div
            class="item-content"
          >{{dataAll.analysisOfElectricityCostStructure.statisticalAnalysisOfElectricity.rearDescribe}}</div>
          <p class="report-title report-title-2">4.2 电力能源及成本结构</p>
          <p class="report-title report-title-3">4.2.1 按照用电性质分项</p>
          <div>
            <pieEchart
              :chartData="this.dataAll.analysisOfElectricityCostStructure.energyAndCostStructure.electricalProperties.pieEcharts"
            ></pieEchart>
          </div>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>部门</td>
              <td colspan="3">用电量(kwh)</td>
              <td colspan="2">比例(%)</td>
            </tr>
            <tr
              v-for="(item,index) in dataAll.analysisOfElectricityCostStructure.energyAndCostStructure.electricalProperties.energyUsedList"
              :key="index"
            >
              <td>{{item.name}}</td>
              <td colspan="3">{{item.value}}</td>
              <td colspan="2">{{item.ratio}}</td>
            </tr>
          </table>
        </div>
        <div class="content">
          <table
            style="margin-top:0px"
            class="report-table"
            border="1"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td>部门</td>
              <td colspan="3">用电费(元)</td>
              <td colspan="2">比例(%)</td>
            </tr>
            <tr
              v-for="(item,index) in dataAll.analysisOfElectricityCostStructure.energyAndCostStructure.electricalProperties.priceList"
              :key="index"
            >
              <td>{{item.name}}</td>
              <td colspan="3">{{item.value}}</td>
              <td colspan="2">{{item.ratio}}</td>
            </tr>
          </table>
          <p class="report-title report-title-3">4.2.2 按照部门用电分项</p>
          <div>
            <pieEchart
              :chartData="this.dataAll.analysisOfElectricityCostStructure.energyAndCostStructure.departmentProperties.pieEcharts"
            ></pieEchart>
          </div>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>部门</td>
              <td colspan="3">年用电量(kwh)</td>
              <td colspan="2">比例(%)</td>
            </tr>
            <tr
              v-for="(item,index) in dataAll.analysisOfElectricityCostStructure.energyAndCostStructure.departmentProperties.energyUsedList"
              :key="index"
            >
              <td>{{item.name}}</td>
              <td colspan="3">{{item.value}}</td>
              <td colspan="2">{{item.ratio}}</td>
            </tr>
          </table>
          <table
            style="margin-top:20px"
            class="report-table"
            border="1"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td>部门</td>
              <td colspan="3">用电费(元)</td>
              <td colspan="2">比例(%)</td>
            </tr>
            <tr
              v-for="(item,index) in dataAll.analysisOfElectricityCostStructure.energyAndCostStructure.departmentProperties.priceList"
              :key="index"
            >
              <td>{{item.name}}</td>
              <td colspan="3">{{item.value}}</td>
              <td colspan="2">{{item.ratio}}</td>
            </tr>
          </table>
        </div>
        <div class="content">
          <p class="report-title report-title-2">4.3 峰平谷用电分析</p>
          <div class="echart-content">
            <div id="echartTwo" style="width:100%;height:100%"></div>
          </div>
          <div>
            <pieEchart
              :chartData="this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.energyUsedList"
            ></pieEchart>
          </div>
          <div>
            <pieEchart
              :chartData="this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.priceList"
            ></pieEchart>
          </div>
          <div
            class="item-content"
            v-html="dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.rearDescribe"
          ></div>
        </div>
        <div class="content">
          <p class="report-title report-title-2">4.4 基本电费分析</p>
          <div style="width:100%;overflow: auto;">
            <table style class="report-table2" border="1" cellspacing="0" cellpadding="0">
              <tr
                v-for="(item,index) in dataAll.analysisOfElectricityCostStructure.basicElectricityAnalysis.title"
                :key="index"
              >
                <td>{{item}}</td>
                <td>{{dataAll.analysisOfElectricityCostStructure.basicElectricityAnalysis.table[0][index]}}</td>
                <td>{{dataAll.analysisOfElectricityCostStructure.basicElectricityAnalysis.table[1][index]}}</td>
                <td>{{dataAll.analysisOfElectricityCostStructure.basicElectricityAnalysis.table[2][index]}}</td>
              </tr>
            </table>
          </div>
          <div
            class="item-content"
          >{{dataAll.analysisOfElectricityCostStructure.basicElectricityAnalysis.rearDescribe}}</div>
          <p class="report-title report-title-2">4.5 力调电费分析</p>

          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td colspan="3"></td>
              <td>峰期电费(元)</td>
              <td>平期电费</td>
              <td>谷期电费</td>
              <td>总费用</td>
              <td>功率因数</td>
              <td>力调系数</td>
              <td>力调电费</td>
            </tr>
            <tr
              v-for="(item,index) in dataAll.analysisOfElectricityCostStructure.electricityAdjustment.table"
              :key="index"
            >
              <td colspan="3">{{item.title}}</td>
              <td>{{item.peakValue}}</td>
              <td>{{item.flatValue}}</td>
              <td>{{item.valleyValue}}</td>
              <td>{{item.totalValue}}</td>
              <td>{{item.powerFactor}}</td>
              <td>{{item.adjustProportion}}</td>
              <td>{{item.adjustPrice}}</td>
            </tr>
          </table>
          <div
            class="item-content"
          >{{dataAll.analysisOfElectricityCostStructure.electricityAdjustment.rearDescribe}}</div>
        </div>
        <div class="content" style="height: 1100px;">
          <p class="report-title">5.企业用水成本分析</p>
          <p class="report-title report-title-2">5.1 水用量统计分析</p>
          <div>
            <echartsItem :chartData="dataAll.waterCostAnalysis.waterUsageStatistics"></echartsItem>
          </div>
          <p class="report-title report-title-2">5.2 水用量及成本结构分析</p>
          <pieEchart
            :unit="'t'"
            :chartData="this.dataAll.waterCostAnalysis.waterCostStructure.pieEcharts"
          ></pieEchart>
          <table class="report-table" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <td>部门</td>
              <td colspan="3">自来水量(t)</td>
              <td colspan="2">比例(%)</td>
            </tr>
            <tr
              v-for="(item,index) in dataAll.waterCostAnalysis.waterCostStructure.energyUsedList"
              :key="index"
            >
              <td>{{item.name}}</td>
              <td colspan="3">{{item.value}}</td>
              <td colspan="2">{{item.ratio}}</td>
            </tr>
          </table>
          <table
            style="margin-top:20px"
            class="report-table"
            border="1"
            cellspacing="0"
            cellpadding="0"
          >
            <tr>
              <td>部门</td>
              <td colspan="3">自来水费用(元)</td>
              <td colspan="2">比例(%)</td>
            </tr>
            <tr
              v-for="(item,index) in dataAll.waterCostAnalysis.waterCostStructure.priceList"
              :key="index"
            >
              <td>{{item.name}}</td>
              <td colspan="3">{{item.value}}</td>
              <td colspan="2">{{item.ratio}}</td>
            </tr>
          </table>
        </div>
        <div class="content">
          <p class="report-title">6.月用能成本分析评价</p>
          <div class="item-content" v-html="dataAll.costAnalysisEvaluate"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import pieEchart from "./echart/pieEchart";
import echartsItem from "./echart/ehartsItem";
import {handleWindowPrint} from "./print";
export default {
  components: {
    pieEchart,
    echartsItem
  },
  props: {
    data: {
      type: String,
      default: () => {}
    },
    downLoadName: {
      type: String,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: () => {}
    }
  },
  watch: {
    data(e) {
      console.log(e);
      this.dataAll = JSON.parse(this.data);
      console.log(this.dataAll);
    }
  },
  data() {
    return {
      dataAll: {},
      unit: "tce/t",
      echartOne: null,
      echartTwo: null,
      echartThree: null,
      echartFour: null,
      echartFive: null,
      echartSix: null,
      Name: ""
    };
  },
  created() {
    // console.log(this.dataAll);
    // console.log(this.data);
    // console.log(JSON.parse(this.data));
    this.Name = this.downLoadName;
    this.dataAll = JSON.parse(this.data);
    console.log(this.dataAll);
    console.log(this.show);
  },
  mounted() {
    console.log(this.dataAll.steamCostAnalysis.steamUsageStatistics);
    // console.log(
    //   this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
    //     .subtitle
    // );
    // console.log(
    //   this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
    //     .y
    // );
    // console.log(
    //   this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
    //     .subtiltle
    // );
    // this.getEchart(
    //   "echartOne",
    //   this.echartOne,
    //   this.electricalCharacteristics.electricityConsumptionAnalysis
    //     .monthElectricityConsumption.echarts.y,
    //   this.electricalCharacteristics.electricityConsumptionAnalysis
    //     .monthElectricityConsumption.echarts.x,
    //   this.electricalCharacteristics.electricityConsumptionAnalysis
    //     .monthElectricityConsumption.echarts.title,
    //   this.electricalCharacteristics.electricityConsumptionAnalysis
    //     .monthElectricityConsumption.echarts.unit,
    //   this.electricalCharacteristics.electricityConsumptionAnalysis
    //     .monthElectricityConsumption.echarts.title,
    //   "bar"
    // );
    this.getEchart(
      "echartTwo",
      this.echartTwo,
      this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
        .y,
      this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
        .x,
      this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
        .title,
      this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
        .unit,
      this.dataAll.analysisOfElectricityCostStructure.peakPingguAnalysis.echarts
        .subtitle,
      "line"
    );
    // this.getEchart(
    //   "echartThree",
    //   this.echartThree,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts.y,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts.x,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts
    //     .title,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts
    //     .unit,
    //   this.electricalCharacteristics.powerUsageAnalysis.powerFactor.echarts
    //     .subtitle,
    //   "line"
    // );
    // this.getEchart(
    //   "echartFour",
    //   this.echartFour,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.y,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.x,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.title,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.unit,
    //   this.electricalCharacteristics.powerUsageAnalysis.transformerLoadRatio
    //     .echarts.subtitle,
    //   "bar"
    // );
    // this.getEchart(
    //   "echartFive",
    //   this.echartFive,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .y,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .x,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .title,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .unit,
    //   this.electricalCharacteristics.powerUsageAnalysis.voltageImbalance.echarts
    //     .subtitle,
    //   "bar"
    // );
    // this.getEchart(
    //   "echartSix",
    //   this.echartSix,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.y,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.x,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.title,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts.unit,
    //   this.electricalCharacteristics.loadCharacteristicAnalysis.echarts
    //     .subtitle,
    //   "line"
    // );
  },
  methods: {
    getEchart(id, chartName, data, xdata, title, unit, legend, type) {
      // console.log(legend);
      // if(legend instanceof Array)
      // console.log(legend instanceof Array);
      let legendtitle = legend;
      if (legendtitle instanceof Array) {
        legendtitle = legend;
        // console.log(legendtitle);
      } else {
        legendtitle = [legend];
        // legendtitle.push(legend);
        // console.log(legendtitle);
      }
      let dataAll = true;
      let dataseries = [];
      let icon = ["diamond", "rect", "triangle"];
      // console.log(typeof data[0]);
      if (typeof data[0] != "string") {
        dataseries.push(
          {
            name: legend[0],
            data: data[0],
            type: "line",
            symbol: icon[0]
          },
          {
            name: legend[1],
            data: data[1],
            type: "bar",
            stack: "广告",
            symbol: icon[0]
          },
          {
            name: legend[2],
            data: data[2],
            type: "bar",
            stack: "广告",
            symbol: icon[1]
          },
          {
            name: legend[3],
            data: data[3],
            type: "bar",
            stack: "广告",
            symbol: icon[2]
          }
        );

        // console.log(dataseries);
      } else {
        dataseries = [
          {
            name: legend,
            data: data,
            type: type
          }
        ];
        // console.log(dataseries);
        // console.log("222");
      }
      let this_ = this;
      chartName = this.$echarts.init(document.getElementById(id));
      var option = {
        title: {
          text: title,
          left: "center"
        },
        grid: {
          x: 60,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10,
          width: "70%"
        },
        color: [
          "#d2b533",
          "#fe3c00",
          "#7928cb",
          "#8eb2f0",
          "#003690",
          "#0db198",
          "#9ff093"
        ],
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: legendtitle,
          top: "20%",
          right: "3%",
          orient: "vertical" //垂直显示
          // icon: ["line", "pin", "diamond"]
        },

        // dataZoom: [
        //   {
        //     type: "inside",
        //     show: true,
        //     realtime: true
        //   },
        //   {
        //     show: true,
        //     realtime: true,
        //     end: 100,
        //     type: "slider",
        //     width: "92%",
        //     left: "center"
        //   }
        // ],
        // toolbox: {
        //   show: true,
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     // restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: xdata,
            name: "日期"
          }
        ],
        yAxis: [
          {
            type: "value",
            name: unit
          }
        ],
        series: dataseries
      };

      chartName.setOption(option, true);
      if (chartName) {
        window.addEventListener("resize", function() {
          chartName.resize();
        });
      }
    },
    savePdf() {
      let scrollHeight = this.$refs.imageDom.scrollHeight;
      document.querySelector("#imageDom").style.height = scrollHeight + "px";
      var title = this.Name;
      html2Canvas(document.querySelector("#imageDom"), {
        allowTaint: true,
        taintTest: false,
        height: this.$refs.imageDom.scrollHeight
      }).then(function(canvas) {
        console.log(canvas);
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(title + ".pdf");
        document.querySelector("#imageDom").style.height = "calc(100% - 60px)";
      });
    },
    savePdf2() {
      var canvass = document.querySelectorAll("#imageDom canvas");
      var noneCanvasImg = document.querySelectorAll(".none-canvas-img");
      let name = this.Name;
      for (let index = 0; index < noneCanvasImg.length; index++) {
        const element = noneCanvasImg[index];
        // 判断是否是IE
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          element.removeNode(true);
        } else {
          element.remove();
        }
      }
      let index = 0;

      for (let k4 = 0; k4 < canvass.length; k4++) {
        let imageURL = canvass[k4].toDataURL("image/png");
        let img = document.createElement("img");
        img.src = imageURL;
        img.setAttribute("style", "max-width: 100%;");
        img.setAttribute("index", k4);
        img.className = "isNeedRemove none-canvas-img";
        // canvass[k4].style.display = 'none'
        // canvass[k4].parentNode.style.width = '100%'
        // canvass[k4].parentNode.style.textAlign = 'center'
        img.onload = function(e) {
          index++;
          const imgIndex = e.currentTarget.attributes.index.value;
          canvass[imgIndex].parentNode.insertBefore(
            img,
            canvass[imgIndex].nextElementSibling
          );
          if (index == canvass.length) {
            const style = `.economize-wrap {
                                              min-width: 794px;
                                              margin: 0px auto;
                                              height: 100%;
                                              overflow: hidden;
                                            }
                                            .btn-content {
                                              padding-bottom: 10px;
                                              padding-left: 10px;
                                              padding-right: 10px;
                                              margin-bottom: 10px;
                                              text-align: right;
                                              border-bottom: 1px solid #e4e7ed;
                                            }
                                            .economize-content {
                                              width: 100%;
                                              margin: 0px auto;
                                              height: calc(100% - 60px);
                                              overflow: auto;
                                            }
                                            .pdf-con {
                                              width: 794px;
                                              margin: 0px auto;
                                            }
                                            .report-title {
                                              font-size: 30px;
                                              text-align: center;
                                              line-height: 1110px;
                                            }
                                           .content {
                                              margin-bottom: 10px;
                                            width: calc(100% - 60px);
                                            height: 1060px;
                                            padding: 30px 30px;
                                            overflow: hidden;
                                            
                                          }
                                          .contentOne {
                                            margin-bottom: 10px;
                                            width: calc(100% - 60px);
                                            height: 1060px;
                                            padding: 30px 30px;
                                            overflow: hidden;

                                          }
                                            .report-table {
                                              width: 100%;
                                            }
                                            
                                            .report-table tr {
                                              height: 30px;
                                              line-height: 30px;
                                            }
                                            
                                            .report-table tr td {
                                              text-align: center;
                                            }
                                            
                                            .report-title {
                                              padding: 10px 0px;
                                              height: 30px;
                                              line-height: 30px;
                                              font-size: 24px;
                                              text-align: left;
                                              font-weight: bold;
                                              margin: 5px;
                                            }
                                            
                                            .report-title-2 {
                                              font-size: 22px;
                                            }
                                            
                                            .report-title-3 {
                                              font-size: 20px;
                                            }
                                            
                                            .item-content {
                                              width: 100%;
                                              text-indent: 30px;
                                              line-height: 30px;
                                            }
                                            .report-table2 {
                                              width: 100%;
                                              font-size: 5px;
                                            }

                                            .report-table2 tr {
                                              height: 20px;
                                              line-height: 20px;
                                            }

                                            .report-table2 tr td {
                                              text-align: center;
                                              white-space: nowrap;
                                            }
                                            .echart-content {
                                              width: 100%;
                                              height: 300px;
                                            }`;
            handleWindowPrint("#imageDom", name, style, this);
          }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.economize-wrap {
  min-width: 794px;
  margin: 0px auto;
  height: 100%;
  overflow: hidden;
}
.btn-content {
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  text-align: right;
  border-bottom: 1px solid #e4e7ed;
}
.economize-content {
  width: 100%;
  margin: 0px auto;
  height: calc(100% - 60px);
  overflow: auto;
  position: absolute;
}
.pdf-con {
  width: 794px;
  margin: 0px auto;
}
.report-title {
  font-size: 30px;
  text-align: center;
  line-height: 1130px;
}
.content {
  margin-bottom: 10px;
  width: calc(100% - 60px);
  height: 1060px;
  padding: 30px 30px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}
.contentOne {
  margin-bottom: 10px;
  width: calc(100% - 60px);
  height: 1060px;
  padding: 30px 30px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
}

.report-table {
  width: 100%;
}

.report-table tr {
  height: 30px;
  line-height: 30px;
}

.report-table tr td {
  text-align: center;
}
.report-table2 {
  width: 100%;
  font-size: 5px;
}

.report-table2 tr {
  height: 20px;
  line-height: 20px;
}

.report-table2 tr td {
  text-align: center;
  white-space: nowrap;
}

.report-title {
  padding: 10px 0px;
  height: 30px;
  line-height: 30px;
  font-size: 24px;
  text-align: left;
  font-weight: bold;
  margin: 0px;
}

.report-title-2 {
  font-size: 22px;
}

.report-title-3 {
  font-size: 20px;
}

.item-content {
  width: 100%;
  text-indent: 30px;
  line-height: 30px;
}

.echart-content {
  width: 100%;
  height: 300px;
}
</style>
<style>
@media print {
  .list-content {
    display: none;
  }
  .tab-content {
    display: none;
  }
  .wrap-print {
    display: none;
  }
}
</style>
